import { Controller } from "@hotwired/stimulus"

import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin      from '@fullcalendar/interaction';
import timeGridPlugin         from '@fullcalendar/timegrid';
import momentTimezonePlugin   from '@fullcalendar/moment-timezone'
import frLocale               from '@fullcalendar/core/locales/fr';

import tippy from 'tippy.js';

import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js"


// import { get } from '@rails/request.js'
import { Calendar } from '@fullcalendar/core';
// import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
// import frLocale from '@fullcalendar/core/locales/fr';
// import interactionPlugin from '@fullcalendar/interaction';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import momentTimezonePlugin from '@fullcalendar/moment-timezone'
// import tippy from 'tippy.js';

// const namesMapping = { Room: 'Salles', Material: 'Matériels'}

const isDateWeekend = (date) => (date.getDay() === 0 || date.getDay() === 6)

flatpickr.localize(French);

// Connects to data-controller="calendar"
export default class extends Controller {
  static targets = ['calendar', 'title', 'dateInput'] // 'date'
  static values = {
    eventUrl: String,
    newBookingUrl: String,
    canSeeAllTimeSlots: { type: Boolean, default: false },
    canCreateBooking: { type: Boolean, default: false },
    translations: { type: Object, default: {} },
    rentableType: String,
    view: { type: String, default: 'resourceTimelineDay' },
    hours: String,
    resources: Object,
  }

  initialize() {
    this.selectSlot = this.selectSlot.bind(this)
    this.datesChanged = this.datesChanged.bind(this)
    this.eventClick = this.eventClick.bind(this)
  }

  get eventUrl() { return this.eventUrlValue.replace(/RentableType/g, this.rentableType) }
  get resources() { return this.resourcesValue[this.rentableType]  }
  get slotMinTime() { return this.hours === 'all' ? '00:00:00' : '08:00:00' }
  get slotMaxTime() {
    if (this.hours === 'all')
      return '24:00:00'
    else if (this.canSeeAllTimeSlotsValue)
      return '20:00:00'
    else
      return '18:00:00'
  }
  get resourceAreaColumns() { return [{ field: 'title', headerContent: this.translationsValue[this.rentableType] }]}
  get title() { return this.calendar.currentData.viewTitle }

  updateView(e) {
    this.view = e.target.value
     this.calendar.changeView(this.view)
  }

  refresh(_e) {
    this.calendar.refetchEvents()
  }

  updateRentableType(e) {
    this.rentableType = e.target.value
    this.calendar.setOption('resourceAreaColumns', this.resourceAreaColumns);
    this.calendar.setOption('resources', this.resources);
    this.calendar.setOption('events', this.eventUrl);
  }

  updateHours(e) {
    this.hours = e.target.value
    this.calendar.setOption('slotMinTime', this.slotMinTime);
    this.calendar.setOption('slotMaxTime', this.slotMaxTime);
  }

  prev() { this.calendar.prev() }
  next() { this.calendar.next() }
  today() { this.calendar.today() }

  selectSlot(info) {
    console.log('selectSlot', info)

    const url = new URL(this.newBookingUrlValue, window.location.origin)
    url.searchParams.set('start_at', info.start.toUTCString())
    url.searchParams.set('end_at', info.end.toUTCString())
    url.searchParams.set('rentable_id', info.resource.id)
    url.searchParams.set('rentable_type', this.rentableType)
    Turbo.visit(url.toString(), { frame: 'turbo_modal' })
  }

  eventClick (info) {
    if (info.event.extendedProps.edit_url)
      Turbo.visit(info.event.extendedProps.edit_url, { frame: 'turbo_modal' })
  }

  eventDidMount(eventObject) {
    if (!eventObject.event.extendedProps.user_can_edit) {
      console.log('event__uneditable')
      eventObject.el.classList.add('event__uneditable')
    }
    else if (!eventObject.event.extendedProps.confirmed) {
      console.log('event__unconfirmed')
      eventObject.el.classList.add('event__unconfirmed')
    }

    if (eventObject.event.extendedProps.tooltip_html) {
      tippy(eventObject.el, {
        content: eventObject.event.extendedProps.tooltip_html,
        theme: 'light',
        allowHTML: true,
      })
    }
  }

  datesChanged(dateInfo) {
    console.log('datesChanged', dateInfo)
    this.fp.setDate(dateInfo.startStr) // just to have the right date selected when open flatpickr
    this.titleTarget.textContent = this.title
  }

  get options() {
    return {
      height: 'auto',
      allDaySlot: false,
      selectable: this.canCreateBookingValue,
      plugins: [momentTimezonePlugin, resourceTimelinePlugin, interactionPlugin, timeGridPlugin],
      schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
      locales: [frLocale],
      locale: 'fr',
      timeZone: 'Europe/Paris',
      initialView: this.view,
      headerToolbar: false,
      slotMinWidth: 30,
      resourceOrder: 'sort',
      resourceAreaColumns: this.resourceAreaColumns, // for set the name of column
      resources: this.resources,
      events: this.eventUrl,
      weekends: this.canSeeAllTimeSlotsValue,
      slotMinTime: this.slotMinTime,
      slotMaxTime: this.slotMaxTime,
      select: this.selectSlot,
      datesSet: this.datesChanged,
      eventClick: this.eventClick,
      eventDidMount: this.eventDidMount
    }
  }

  connect() {
    this.initializeFlatpickr()
    this.rentableType = this.rentableTypeValue
    this.hours        = this.hoursValue
    this.view         = this.viewValue

    this.calendar     = new Calendar(this.calendarTarget, this.options)
    this.calendar.render()
  }

  updateDate() {
    this.calendar.gotoDate(this.dateInputTarget.value)
  }

  initializeFlatpickr() {
    this.fp = flatpickr(
      this.dateInputTarget,
      {
        disable: this.canSeeAllTimeSlotsValue ? [] : [isDateWeekend],
      }
    )
  }
}
